export enum ReferenceSystemType {
  FIXED = 'fixed',
  ATTACHED_TO_NODE = 'attached_to_node',
}
